<script lang="ts">
    import Text from '../Text.svelte';
    import Emoji from '../Emoji.svelte';
    import Image from '../Image/Image.svelte';
    import clsx from 'clsx';
    import { TEXT_SIZE_MAP } from './constants';

    // Utils
    import { getListItemVisualSizeProps } from './helper';
    import { getBorderRadius } from '$lib/global/helper/border-radius';

    // Types
    import type {
        Align,
        BorderRadius,
        VisualSize,
        Box as BoxType,
    } from '$lib/types/Components/SharedTypes';
    import type { RawDraftContentState } from 'draft-js';

    export let align: Align = 'left';
    export let textSize: 'small' | 'medium' = 'small';
    export let visualSize: VisualSize = 'small';
    export let color = 'black';
    export let draft: RawDraftContentState;
    export let emoji = ':telescope:';
    export let imageSrc = '';
    export let mediaType = 'emoji';
    export let cornerRounding: BorderRadius = 'small';
    export let linkColor = '';

    let visualProps: {
            size: number;
            emojiPadding: number;
        },
        emojiSize: number;
    let visualClasses: string, imageClasses: string, textClasses: string;

    const alignCenter = align === 'center';
    const cornerRoundingMajor = cornerRounding === 'large';

    visualProps = getListItemVisualSizeProps({
        align,
        visualSize,
        srcType: mediaType,
    });
    emojiSize = visualProps?.size && visualProps?.size - visualProps?.emojiPadding * 2;

    const textBox: BoxType = {
        top: 'none',
        right: 'none',
        bottom: 'none',
        left: 'none',
        backgroundColor: 'transparent',
    };

    visualClasses = 'flex-shrink-0 flex items-center justify-center';

    $: imageClasses = clsx(visualClasses, {
        ['rounded-full overflow-hidden']: cornerRoundingMajor,
    });

    $: textClasses = clsx('text flex items-center flex-grow break-words', {
        ['w-full mt-3']: alignCenter,
        ['ml-6 min-w-0']: !alignCenter,
    });
</script>

<div
    class="box-border flex w-full align-top {alignCenter ? 'flex-col items-center' : 'items-start'}"
>
    {#if mediaType === 'emoji'}
        <div
            class={visualClasses}
            style={`width: ${visualProps?.size}px; height: ${visualProps?.size}px;`}
        >
            <Emoji {emoji} size={emojiSize ? `${emojiSize}px` : undefined} />
        </div>
    {/if}
    {#if mediaType === 'image'}
        <div
            class={imageClasses}
            style={`transform: translateZ(0); width: ${visualProps?.size}px; height: ${visualProps?.size}px;`}
        >
            <Image
                src={imageSrc}
                size="listItem"
                fixedMaxWidth={visualProps?.size}
                borderRadiusClass={getBorderRadius('listImage')}
            />
        </div>
    {/if}
    <div
        class={textClasses}
        style={`min-height: ${alignCenter ? 0 : visualProps?.size}px; font-size: ${
            TEXT_SIZE_MAP[textSize]
        }`}
    >
        <Text raw={draft} box={textBox} inheritSize {color} {align} {linkColor} />
    </div>
</div>

<style lang="scss">
    .text > :global(div) {
        @apply h-full w-full;
    }

    .text :global(h4),
    .text :global(p) {
        padding: 0 !important;
    }
</style>
